import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Cash(props) {
  if (props.status === "Returned" || props.status === "Delivered") {
    return (
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M8.24156 13.7559L5.24421 10.7595C4.9186 10.434 4.9186 9.90819 5.24421 9.58268C5.56983 9.25717 6.09583 9.25717 6.42144 9.58268L8.83435 11.9864L14.5786 6.24413C14.9042 5.91862 15.4302 5.91862 15.7558 6.24413C16.0814 6.56964 16.0814 7.09546 15.7558 7.42097L9.41879 13.7559C9.10152 14.0814 8.56717 14.0814 8.24156 13.7559Z"
          fill="#00AB59"
          stroke="#00AB59"
        />
      </Svg>
    );
  }
  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M19.9824 10.7589C19.9824 11.64 19.3459 12.3008 18.4907 12.3008C12.7934 12.3008 7.09616 12.3008 1.3989 12.3008C0.636466 12.2939 0 11.6469 0 10.8553C0 7.72327 0 4.59128 0.00662986 1.4593C0.00662986 0.715882 0.563538 0.0963687 1.27293 0.0206504C1.38564 0.00688348 1.50498 0 1.62432 0C7.1934 0 12.7625 0 18.3249 0C18.7758 0 19.2001 0.0826018 19.5316 0.426776C19.8233 0.722766 19.9758 1.08071 19.9824 1.5006C20.022 4.58574 19.9824 7.67352 19.9824 10.7589Z"
        fill="#04BF66"
      />
      <Path
        d="M15.2221 6.16733C15.242 8.78305 13.1735 10.9926 10.5547 10.9513C8.03538 10.91 6.00665 8.83812 6.00002 6.16044C5.99339 3.52407 8.04201 1.33512 10.694 1.36954C13.1735 1.41084 15.2354 3.5103 15.2221 6.16733Z"
        fill="#00AB59"
      />
      <Path
        d="M3.61324 2.66413C3.65302 3.22858 3.19556 3.71731 2.6055 3.72419C2.00218 3.73107 1.56461 3.26988 1.55798 2.65037C1.55798 2.0515 2.0287 1.54901 2.59224 1.56278C3.1823 1.57654 3.67954 2.09969 3.61324 2.66413Z"
        fill="#00AB59"
      />
      <Path
        d="M16.3227 9.64349C16.3294 9.04462 16.82 8.54901 17.3504 8.56278C17.9669 8.57655 18.3979 8.99644 18.3979 9.6366C18.4045 10.2699 17.9603 10.6898 17.3769 10.7173C16.8332 10.7517 16.3294 10.2148 16.3227 9.64349Z"
        fill="#00AB59"
      />
      <Path
        d="M11.4724 9.75471C11.4667 9.73177 11.4437 9.72029 11.4265 9.70308C10.6349 8.91146 9.83752 8.11983 9.04589 7.3282C9.01721 7.29952 9 7.27084 9 7.22495C9 6.98402 9.00574 6.74309 9 6.49642C9 6.44479 9.01721 6.43332 9.06884 6.43332C9.53922 6.43332 10.0096 6.43332 10.4857 6.43332C11.0536 6.43906 11.5126 6.07766 11.6904 5.62448C11.6961 5.61301 11.7019 5.60728 11.6961 5.59007C11.6732 5.59007 11.6502 5.59007 11.6273 5.59007C10.784 5.59007 9.93504 5.59007 9.09178 5.59007C9.02868 5.59007 9.00574 5.57859 9.00574 5.50976C9.01147 5.2803 9.01147 5.04511 9.00574 4.81565C9.00574 4.75828 9.01721 4.74107 9.08031 4.74107C9.9293 4.74107 10.7726 4.74107 11.6215 4.74107C11.6445 4.74107 11.6674 4.74107 11.7019 4.74107C11.6732 4.63782 11.6273 4.55177 11.5699 4.46573C11.3175 4.10433 10.9791 3.90356 10.5374 3.89782C10.0555 3.89208 9.56791 3.89208 9.08605 3.89782C9.02868 3.89782 9.01147 3.88061 9.01147 3.82325C9.01721 3.58805 9.01721 3.34712 9.01147 3.11193C9.01147 3.0603 9.02868 3.04883 9.07457 3.04883C10.4513 3.04883 11.8281 3.04883 13.2105 3.04883C13.2564 3.04883 13.2736 3.0603 13.2736 3.10619C13.2679 3.34712 13.2736 3.58805 13.2736 3.83472C13.2736 3.88635 13.2622 3.89782 13.2105 3.89782C12.9065 3.89782 12.5967 3.89782 12.2927 3.89782C12.2698 3.89782 12.2468 3.89782 12.2239 3.89782C12.2181 3.92077 12.2353 3.93224 12.2411 3.94371C12.4017 4.16743 12.5164 4.4141 12.5738 4.68371C12.5853 4.7296 12.6082 4.74107 12.6541 4.74107C12.8434 4.74107 13.0327 4.74107 13.222 4.74107C13.2622 4.74107 13.2736 4.74681 13.2736 4.7927C13.2736 5.03937 13.2736 5.29177 13.2736 5.53844C13.2736 5.58433 13.2564 5.59007 13.2163 5.59007C13.027 5.59007 12.8377 5.59007 12.6484 5.59007C12.6082 5.59007 12.591 5.60154 12.5795 5.64169C12.3501 6.49642 11.8051 7.02991 10.9389 7.23642C10.7898 7.27084 10.6349 7.28231 10.4857 7.28231C10.3997 7.28231 10.3194 7.28231 10.2219 7.29952C10.2391 7.31673 10.2563 7.3282 10.2735 7.34541C10.8643 7.93626 11.4552 8.52712 12.046 9.11223C12.0862 9.15239 12.0862 9.1696 12.046 9.20402C11.8625 9.38758 11.6789 9.57115 11.4953 9.75471C11.4839 9.75471 11.4781 9.75471 11.4724 9.75471Z"
        fill="white"
      />
    </Svg>
  );
}

export default Cash;
